import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import { FC } from 'react';

export const SpaceHomePageSkeleton: FC = () => (
  <Box sx={{ display: 'flex', flexDirection: 'column' }}>
    {/* Breadcrumbs */}
    <Box display="flex" gap={1} mb={2} alignItems="center">
      <Skeleton variant="text" width={120} height={20} />
      <Skeleton variant="text" width={8} height={20} />
      <Skeleton variant="text" width={50} height={20} />
    </Box>

    {/* Banner image */}
    <Skeleton
      variant="rectangular"
      sx={{
        width: { xs: '100%', md: 993 },
        height: { xs: 93, sm: 200, md: 279 },
        borderRadius: { xs: '5px', md: '15px' },
      }}
    />

    {/* Two-column layout */}
    <Box
      sx={{
        mt: { xs: 1.5, md: 3 },
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        gap: { xs: '30px', md: '80px', lg: '100px' },
        alignItems: 'flex-start',
        width: '100%',
      }}
    >
      {/* Left — description text lines */}
      <Box
        sx={{ flex: '1 1 57%', maxWidth: { xs: '100%', md: 500 }, display: 'flex', flexDirection: 'column', gap: 1 }}
      >
        <Skeleton variant="text" width="100%" height={18} />
        <Skeleton variant="text" width="95%" height={18} />
        <Skeleton variant="text" width="90%" height={18} />
        <Skeleton variant="text" width="80%" height={18} />
        <Skeleton variant="text" width="85%" height={18} />
        <Skeleton variant="text" width="70%" height={18} />
      </Box>

      {/* Right — module cards */}
      <Box
        sx={{
          flex: '1 1 43%',
          maxWidth: { xs: '100%', md: 400 },
          display: 'flex',
          flexDirection: 'column',
          gap: '17px',
        }}
      >
        {Array.from({ length: 4 }).map((_, i) => (
          // oxlint-disable-next-line react/no-array-index-key
          <Skeleton key={i} variant="rectangular" height={56} sx={{ borderRadius: 2 }} />
        ))}
      </Box>
    </Box>
  </Box>
);
